import React from 'react';
import { NotificationsIcon, ClearIcon } from './icons/ViewTicketsIcons';

const NotificationSnackbar = ({
  isOpen,
  message,
  onClose
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed top-4 right-4 z-50 animate-fade-in">
      <div className="bg-white border-l-4 border-blue-600 px-6 py-4 rounded-lg shadow-lg min-w-[300px] max-w-md font-poppins">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <NotificationsIcon className="w-5 h-5 text-blue-600" />
            <span className="font-medium text-gray-900">{message}</span>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
          >
            <ClearIcon className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationSnackbar;
